import { render, staticRenderFns } from "./EditSituacaoLocal.vue?vue&type=template&id=6d198522"
import script from "./EditSituacaoLocal.vue?vue&type=script&lang=js"
export * from "./EditSituacaoLocal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports